import NiceModal from '@ebay/nice-modal-react';
import { ActionIcon, Group, Tooltip, Text, Table } from '@mantine/core';
import { IconEdit, IconTrash } from '@tabler/icons-react';

import { useRemoveTrafficSource } from '../../api/removeTrafficSource';
import { trafficSourceTypes } from '../../types';
import { EditModal } from '../EditModal';

import { ConfirmModal } from '@/components/Modals/Confirm';

export const BodyRow = ({ trafficSource }: { trafficSource: trafficSourceTypes.TrafficSource }) => {
  const removeTrafficSource = useRemoveTrafficSource();

  return (
    <Table.Tr key={trafficSource._id}>
      <Table.Td>
        <Text size="sm">{trafficSource.name}</Text>
      </Table.Td>
      <Table.Td>
        <Text size="sm">{trafficSource.key}</Text>
      </Table.Td>
      <Table.Td>
        <Text size="sm">{trafficSource.command}</Text>
      </Table.Td>
      <Table.Td>
        <Group>
          <ActionIcon
            variant="filled"
            radius="md"
            onClick={() =>
              NiceModal.show(EditModal, {
                trafficSourceId: trafficSource._id,
                initialValues: {
                  name: trafficSource.name,
                  key: trafficSource.key,
                  command: trafficSource.command,
                },
              })
            }
          >
            <Tooltip label="Edit Traffic Source">
              <IconEdit />
            </Tooltip>
          </ActionIcon>
          <ActionIcon
            variant="filled"
            color="red"
            radius="md"
            onClick={() =>
              NiceModal.show(ConfirmModal, {
                title: `Remove Traffic Source (${trafficSource.name})?`,
                onSuccess: () => removeTrafficSource.mutate({ _id: trafficSource._id }),
              })
            }
          >
            <Tooltip label="Remove Traffic Source">
              <IconTrash />
            </Tooltip>
          </ActionIcon>
        </Group>
      </Table.Td>
    </Table.Tr>
  );
};
